// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__Twab7","wrap":"Textarea_wrap__hk6rN","placeholder":"Textarea_placeholder__bQ+GA"};